import React, { memo, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import parse from 'html-react-parser';
import { Tooltip } from '@material-ui/core';
import { context } from '../../../../globalState/GlobalState';
import { FORM_DELETED, FORM_NOT_PUBLISHED } from '../../../../catalog/Comments';
import PlaceholderComponent1 from '../../placeholderComponents/placeholderComponent1/PlaceholderComponent1';
import { FormItemType } from '../../../../catalog/enums/FormItemType';
import TextField1 from '../../textFields/textField1/TextField1';
import Select1 from '../../selects/select1/Select1';
import ShareComponent1 from '../../shareComponents/shareComponent1/ShareComponent1';
import Title1 from '../../title/title1/Title1';
import './css/FormComponent1.css';
import Button1 from '../../buttons/Button1';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { getHTMLTextFromNormalText, getOptimXBackgroundOpacityStyle, getOptimXBackgroundStyle } from '../../../../catalog/Website';
import { sendErrorAnalytics } from '../../../../catalog/Analytics';
import { RECAPTCHA_NOT_VERIFIED } from '../../../../catalog/NotificationsComments';
import { getFormShareTitle, getFormURL } from '../../../../catalog/Social';
import { showFeesFromCents, showPriceFromCents, showProfitFromCents, showPlatformFees } from '../../../../catalog/Price';
import { checkFormsValidity } from '../../../../catalog/Store';
import Spinner1 from '../../spinners/spinner1/Spinner1';
import { reCaptchaSiteKey } from '../../../../catalog/TeamInfo';

const Recaptcha = require('react-recaptcha');

const initialState = {
    verified: false,
};

function reducer(state, action) {
    switch (action.type) {
        case 'reset':
            return { ...initialState };
        case 'setVerified':
            return { ...state, verified: action.verified };
        default:
            return initialState;
    }
}

const FormComponent1 = (props) => {
    const { id, title, formItems, formPaymentItems, paymentOptionSelected, deleted, published, savePressed, loadingSpinner, submissionLoadingSpinner, setState, saveHandler } = props;
    const { globalState } = useContext(context);
    const [state, setLocalState] = useReducer(reducer, initialState);
    const { enqueueSnackbar } = useSnackbar();

    const verifyCallback = () => {
        setLocalState({ type: 'setVerified', verified: true });
    };

    const checkFields = () => {
        if (state.verified === null || state.verified === undefined || state.verified === false) {
            sendErrorAnalytics('recaptcha');
            enqueueSnackbar(RECAPTCHA_NOT_VERIFIED, { variant: 'error' });
            return false;
        }

        return true;
    };

    const saveHandlerLocal = () => {
        if (checkFields()) {
            saveHandler();
        }
    };

    const placeholderFormContent = () => {
        if (deleted) {
            return (<PlaceholderComponent1 text={FORM_DELETED} />);
        } if (!published) {
            return (<PlaceholderComponent1 text={FORM_NOT_PUBLISHED} />);
        } if (formPaymentItems.length > 0 && !checkFormsValidity(globalState)) {
            return (<PlaceholderComponent1 text={FORM_NOT_PUBLISHED} />);
        }
        return null;
    };

    const showForm = () => {
        if (deleted) {
            return false;
        } if (!published) {
            return false;
        }
        if (formPaymentItems.length > 0 && !checkFormsValidity(globalState)) {
            return false;
        }
        return true;
    };

    const getPrice = () => {
        if (formPaymentItems.length > 0) {
            return (
                <>
                    {showPlatformFees ? (
                        <>
                            <div className="form-component1-subprice-footer-container m-t-30px">
                                <p className="form-component1-subprice-footer-total-label alegreya-font-family font-weight-800 font-size-2xl text-uppercase text-right-align m-t-0 m-b-0">Subtotal:</p>
                                <p className="form-component1-subprice-footer-total text-right-align m-t-0 m-b-0">{showProfitFromCents(formPaymentItems[paymentOptionSelected].price)}</p>
                            </div>
                            <div className="form-component1-subprice-footer-container">
                                <p className="form-component1-subprice-footer-total-label alegreya-font-family font-weight-800 font-size-2xl text-uppercase text-right-align m-t-0 m-b-0">Platform Fee:</p>
                                <p className="form-component1-subprice-footer-total text-right-align m-t-0 m-b-0">{showFeesFromCents(formPaymentItems[paymentOptionSelected].price)}</p>
                            </div>
                        </>
                    ) : null}
                    <div className="form-component1-price-footer-container">
                        <p className="form-component1-price-footer-total-label alegreya-font-family font-weight-800 text-uppercase font-size-3xl text-center-align m-t-0 m-b-0">Total:</p>
                        <p className="form-component1-price-footer-total text-right-align m-t-0 m-b-0">{showPriceFromCents(formPaymentItems[paymentOptionSelected].price)}</p>
                    </div>
                </>
            );
        }
        return null;
    };

    const isTitleInFormPaymentItem = () => {
        let titleExists = false;

        formPaymentItems.forEach((formPaymentItem) => {
            if (formPaymentItem.title) {
                titleExists = true;
            }
        });

        return titleExists;
    };

    const isDescriptionInFormPaymentItem = () => {
        let titleExists = false;

        formPaymentItems.forEach((formPaymentItem) => {
            if (formPaymentItem.title) {
                titleExists = true;
            }
        });

        return titleExists;
    };

    const getFormPaymentItem = (formPaymentItem, index) => {
        if (isValidString(formPaymentItem.stripePriceId) && isTitleInFormPaymentItem()) {
            return (
                <div className="form-component1-payment-option-detailed" style={paymentOptionSelected === index ? { ...getOptimXBackgroundOpacityStyle(globalState) } : null} onClick={() => { setState({ type: 'setPaymentOption', option: index }); }}>
                    <div className="form-component1-title">
                        <p className="normal-font-family font-size-xl font-weight-500 text-left-align text-uppercase m-t-0 m-b-20px">{isValidString(formPaymentItem.title) ? formPaymentItem.title : `Payment Option: ${showPriceFromCents(formPaymentItem.price)}`}</p>
                        <p className="normal-font-family font-size-m font-weight-300 text-left-align m-t-0 m-b-0">{parse(getHTMLTextFromNormalText(formPaymentItem.description))}</p>
                    </div>
                    <div className={`form-component1-price ${paymentOptionSelected === index ? 'selected' : ''}`} style={paymentOptionSelected === index ? { ...getOptimXBackgroundStyle(globalState), borderColor: globalState.websiteStyles.colors.primaryColor } : null} onClick={() => { setState({ type: 'setPaymentOption', option: index }); }}>
                        <p className="m-t-0 m-b-0">{showPriceFromCents(formPaymentItem.price)}</p>
                    </div>
                </div>
            );
        }
        if (isValidString(formPaymentItem.stripePriceId) && isDescriptionInFormPaymentItem()) {
            return (
                <Tooltip title={formPaymentItem.description} placement="top" arrow>
                    <div className={`form-component1-payment-option ${paymentOptionSelected === index ? 'selected' : ''}`} style={paymentOptionSelected === index ? { ...getOptimXBackgroundStyle(globalState), borderColor: globalState.websiteStyles.colors.primaryColor } : null} onClick={() => { setState({ type: 'setPaymentOption', option: index }); }}>
                        <p className="m-t-0 m-b-0">{showPriceFromCents(formPaymentItem.price)}</p>
                    </div>
                </Tooltip>
            );
        }
        if (isValidString(formPaymentItem.stripePriceId)) {
            return (
                <div className={`form-component1-payment-option ${paymentOptionSelected === index ? 'selected' : ''}`} style={paymentOptionSelected === index ? { ...getOptimXBackgroundStyle(globalState), borderColor: globalState.websiteStyles.colors.primaryColor } : null} onClick={() => { setState({ type: 'setPaymentOption', option: index }); }}>
                    <p className="m-t-0 m-b-0">{showPriceFromCents(formPaymentItem.price)}</p>
                </div>
            );
        }

        return null;
    };

    const getFormItem = (formItem) => {
        if (formItem.type === FormItemType.TEXT) {
            return (
                <div className="text-left-align normal-font-family m-t-20px m-b-0 font-weight-400 line-height-wide font-spacing-wide full-width">
                    {parse(getHTMLTextFromNormalText(`${formItem.text}\n\n`))}
                </div>
            );
        }
        if (formItem.type === FormItemType.TEXTFIELD_TEXT) {
            return (
                <TextField1
                    title={formItem.title}
                    halfWidth={formItem.halfWidth}
                    required={formItem.required}
                    helperText={formItem.helperText}
                    error={savePressed && formItem.required && !isValidString(formItem.value)}
                    value={formItem.value}
                    onChange={(event) => { setState({ type: 'setFormItem', id: formItem.id, value: event.target.value, valueTitle: event.target.value }); }}
                />
            );
        } if (formItem.type === FormItemType.TEXTFIELD_DATE) {
            return (
                <TextField1
                    title={formItem.title}
                    type="date"
                    halfWidth={formItem.halfWidth}
                    required={formItem.required}
                    helperText={formItem.helperText}
                    error={savePressed && formItem.required && !isValidString(formItem.value)}
                    value={formItem.value}
                    onChange={(event) => { setState({ type: 'setFormItem', id: formItem.id, value: event.target.value, valueTitle: event.target.value }); }}
                />
            );
        } if (formItem.type === FormItemType.TEXTFIELD_NUMBER) {
            return (
                <TextField1
                    title={formItem.title}
                    type="number"
                    halfWidth={formItem.halfWidth}
                    required={formItem.required}
                    helperText={formItem.helperText}
                    error={savePressed && formItem.required && !isValidString(formItem.value)}
                    value={formItem.value}
                    onChange={(event) => { setState({ type: 'setFormItem', id: formItem.id, value: event.target.value, valueTitle: event.target.value }); }}
                />
            );
        } if (formItem.type === FormItemType.TEXTFIELD_MULTILINE_TEXT) {
            return (
                <TextField1
                    title={formItem.title}
                    halfWidth={formItem.halfWidth}
                    required={formItem.required}
                    helperText={formItem.helperText}
                    error={savePressed && formItem.required && !isValidString(formItem.value)}
                    rows={formItem.lines}
                    value={formItem.value}
                    onChange={(event) => { setState({ type: 'setFormItem', id: formItem.id, value: event.target.value, valueTitle: event.target.value }); }}
                />
            );
        } if (formItem.type === FormItemType.SELECT_OPTIONS) {
            return (
                <Select1
                    title={formItem.title}
                    options={formItem.options.map((option) => {
                        return { value: option.id, title: option.title };
                    })}
                    halfWidth={formItem.halfWidth}
                    required={formItem.required}
                    helperText={formItem.helperText}
                    error={savePressed && formItem.required && !isValidString(formItem.value)}
                    value={formItem.value}
                    onChange={(event) => {
                        let valueTitle = '';
                        formItem.options.forEach((option) => {
                            if (option.id === event.target.value) {
                                valueTitle = option.title;
                            }
                        });
                        setState({ type: 'setFormItem', id: formItem.id, value: event.target.value, valueTitle });
                    }}
                />
            );
        }
        return null;
    };

    return (
        <div className="form-component1-container box-shadow-black bg-white curve-border-20px x-center p-t-20px p-b-20px p-l-50px p-r-50px m-t-50px m-b-200px">
            <Title1 title={title} />
            {showForm() ? (
                <>
                    {loadingSpinner ? <Spinner1 color={globalState.websiteStyles.colors.primaryColor} /> : (
                        <>
                            <ShareComponent1
                                title="Form"
                                url={getFormURL(globalState, id)}
                                shareTitle={getFormShareTitle(title, globalState.teamAlias)}
                                marginLeft={0}
                                marginTop={0}
                                marginBottom={50}
                                mobileMarginTop={0}
                                mobileMarginLeft={0}
                                mobileMarginBottom={50}
                            />
                            <p className="text-left-align m-t-40px m-b-0px">Fields marked with an * are required</p>
                            <div className="form-component1-formtypes">
                                {formItems.map((formItem) => {
                                    return (
                                        <React.Fragment key={formItem.id}>
                                            {getFormItem(formItem)}
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                            {formPaymentItems.length > 1 ? (
                                <>
                                    <p className="textfield-title text-left-align m-t-50px m-b-0" style={{ color: 'gray' }}>PAYMENT OPTIONS*</p>
                                    <div className="form-component1-payment-options">
                                        {formPaymentItems.map((formPaymentItem, index) => {
                                            return (
                                                <React.Fragment key={formPaymentItem.id}>
                                                    {getFormPaymentItem(formPaymentItem, index)}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </>
                            ) : null}
                            {getPrice()}
                            <div className="form-component1-submit-row m-t-20px">
                                <Recaptcha
                                    sitekey={reCaptchaSiteKey}
                                    render="explicit"
                                    verifyCallback={verifyCallback}
                                />
                                <Button1
                                    title={formPaymentItems.length > 0 ? 'Pay now' : 'Submit'}
                                    backgroundColor={globalState.websiteStyles.colors.primaryColor}
                                    borderColor={globalState.websiteStyles.colors.primaryColor}
                                    fontColor={isValidString(globalState.websiteStyles.colors.fontColor) ? `${globalState.websiteStyles.colors.fontColor}` : 'white'}
                                    fontSize="1rem"
                                    fontFamily="HelveticaNeue-CondensedBold, Roboto Condensed, Helvetica Neue, Helvetica,Arial, sans-serif"
                                    borderRadius="5px"
                                    height="44px"
                                    width="300px"
                                    onClick={saveHandlerLocal}
                                    loadingSpinner={submissionLoadingSpinner}
                                />
                            </div>
                        </>
                    )}
                </>
            ) : placeholderFormContent()}
            {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                <img src={globalState.logo.logo2} className="form-component1-icon m-t-50px m-b-0" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
            ) : null}
        </div>
    );
};

FormComponent1.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    formItems: PropTypes.array.isRequired,
    formPaymentItems: PropTypes.array.isRequired,
    paymentOptionSelected: PropTypes.number.isRequired,
    deleted: PropTypes.bool.isRequired,
    published: PropTypes.bool.isRequired,
    savePressed: PropTypes.bool.isRequired,
    loadingSpinner: PropTypes.bool,
    submissionLoadingSpinner: PropTypes.bool,
    setState: PropTypes.func.isRequired,
    saveHandler: PropTypes.func.isRequired,
};

FormComponent1.defaultProps = {
    loadingSpinner: false,
    submissionLoadingSpinner: false,
};

export default memo(FormComponent1);
